import { render, staticRenderFns } from "./RingSizeInstructions.vue?vue&type=template&id=662180da&scoped=true"
import script from "./RingSizeInstructions.vue?vue&type=script&lang=ts"
export * from "./RingSizeInstructions.vue?vue&type=script&lang=ts"
import style0 from "./RingSizeInstructions.vue?vue&type=style&index=0&id=662180da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662180da",
  null
  
)

export default component.exports